import { jsPDF } from 'jspdf';
import { determineCurrentTheme } from './utils';
import { headerBackgroundColor, siteTitle } from './constants';

export const createPdf = ({
  pdf,
  canvasDataUrl,
  imageWidth,
  imageHeight,
  verticalMargin,
  name,
  ciscoLogoDataUrl,
  topologyTitleOverflowCoordinate,
}: ExportCreatePdf): jsPDF => {
  const currentTheme = determineCurrentTheme();

  currentTheme === 'light'
    ? pdf.setFillColor(255, 255, 255)
    : pdf.setFillColor(15, 33, 58);
  pdf.rect(0, 0, imageWidth, pdf.internal.pageSize.height, 'F');
  pdf.addImage(
    canvasDataUrl,
    'PNG',
    0,
    verticalMargin,
    imageWidth,
    imageHeight,
  );
  pdf.setFillColor(headerBackgroundColor);
  pdf.rect(0, 0, imageWidth, 10, 'F');
  pdf.addImage(ciscoLogoDataUrl, 'PNG', 6, 1, 8, 7);
  pdf.setTextColor('white');
  pdf.setFontSize(12);
  pdf.text(siteTitle, 18, 7);
  pdf.setFontSize(8);
  pdf.text(name, 68, 7);
  pdf.setFillColor(headerBackgroundColor);
  pdf.rect(topologyTitleOverflowCoordinate, 0, 10, 10, 'F');

  return pdf;
};
